module.exports = "<div [ngClass]=\"{'geo-input--error': (!model.id && isRequired && submitted)}\" style=\"margin-top: 0;\">\n    <label>{{label}} <abbr *ngIf=\"isRequired\">*</abbr></label>\n    <div>\n        <span class=\"error-alert\" *ngIf=\"(!model.id && isRequired && submitted)\">Este campo é obrigatório.</span>\n        <select class=\"select2\" [disabled]=\"isDisabled\" [(ngModel)]=\"model\" ></select>\n    </div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/shared/components/autocomplete/autocomplete.component.html
 ** module id = 102
 ** module chunks = 0
 **/